export { DarkImageContainer } from './dark_image_container';
export type { DarkImageContainerProps } from './dark_image_container';
